import NewsStore from './news';
import DateStore from './date';
import TimeStore from './time';
import ScoreStore from './score';
import ScenarioStore from './scenario';
import ShipmentStore from './GameSessionStore/ShipmentStore';
import PresetsStore from './presets/presetsStore';
import FinanceData from './financeData'
import CropPlan from './cropPlan';
import ReceptionTransportStore from "./GameSessionStore/ReceptionTransportStore";
import ReceptionBunkersStore from "./GameSessionStore/ReceptionBunkersStore";
import DCunitsStore from "./GameSessionStore/DCunitsStore";
import StorageStore from "./GameSessionStore/StorageStore";
import OffersStore from "./offersStore";

export const transportStore = new ReceptionTransportStore();

export const receptionBunkersStore = new ReceptionBunkersStore();

export const dcUnitsStore = new DCunitsStore();
export const storageStore = new StorageStore();

export const shipment = new ShipmentStore();

export const cropPlan = new CropPlan();
export const finance = new FinanceData();


export const offers = new OffersStore();
export const time = new TimeStore();
export const date = new DateStore();
export const news = new NewsStore();
export const score = new ScoreStore();
export const scenario = new ScenarioStore();
export const presets = new PresetsStore();


// WEBPACK FOOTER //
// ./src/shared/stores/index.js